import {
  OwnUpComponentLibraryProvider,
  OwnUpGridContainer,
  OwnUpGridItem,
  OwnUpGridWrapper,
  OwnUpHeadlineBook,
  OwnUpSpinner
} from '@rategravity/own-up-component-library';
import { useEffect, useState } from 'react';
import React from 'react';
import styled from 'styled-components';
import { fetchPricingTiersApi, PricingTier } from '../../modules/api/pricing-tiers';

const StyledTable = styled.table`
  width: auto;
  border: 1px solid black;
  border-collapse: collapse;
  td {
    white-space: nowrap;
    padding: 8px;
  }
  th {
    padding: 25px;
  }
  th,
  td {
    text-align: left;
    border: 1px solid black;
    border-collapse: collapse;
  }
`;

export const PricingTiersPage = () => {
  const [pricingTiers, setPricingTiers] = useState<PricingTier[]>([]);
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    // On page load, fetch the template lender rules
    void (async () => {
      const tiers = await fetchPricingTiersApi();
      const sortedTiers = tiers.sort((a, b) => a.name.localeCompare(b.name));
      setPricingTiers(sortedTiers);
      setIsLoading(false);
    })();
  }, [isLoading]);

  if (isLoading) {
    return <OwnUpSpinner />;
  }

  return (
    <OwnUpComponentLibraryProvider>
      <OwnUpGridWrapper>
        <OwnUpGridContainer variant="slim">
          <OwnUpGridItem xs={12}>
            <br />
            <OwnUpHeadlineBook variant="h1" style={{ textAlign: 'center' }}>
              Pricing Tiers
            </OwnUpHeadlineBook>
            <br />
          </OwnUpGridItem>
          <StyledTable>
            <thead>
              <th>Tier Name</th>
              <th>Price</th>
            </thead>
            <tbody>
              {pricingTiers.map((tier) => (
                <tr key={tier.name}>
                  <td>{tier.name}</td>
                  <td>${tier.price}</td>
                </tr>
              ))}
            </tbody>
          </StyledTable>
        </OwnUpGridContainer>
      </OwnUpGridWrapper>
    </OwnUpComponentLibraryProvider>
  );
};
